import { columns } from "../../../../dtos/columns";
import { ErroresArchivosExcel } from "../models/erroresArchivoExcel";

interface IProps {
    isArchivo: boolean;
}

export function UseColumnsErrores({isArchivo} : IProps){

    const COLUMNS_ERRORES: columns<ErroresArchivosExcel>[] = [
        {
            name: isArchivo ? 'Celda' : 'Número operación',
            selector: (row: ErroresArchivosExcel) => row.celda,
            sortable: true,
            sortField: 'celda',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Descripción',
            selector: (row: ErroresArchivosExcel) => row.descripcion,
            sortable: true,
            sortField: 'descripcion',
            wrap: true,
            alling: 'left',
            export: true,
        },
    ]

    if (!isArchivo){
        COLUMNS_ERRORES.unshift(
            {
                name: 'Línea/Fila',
                selector: (row: ErroresArchivosExcel) => row.numeroLinea,
                sortable: true,
                sortField: 'numeroLinea',
                wrap: true,
                alling: 'left',
                export: true,
            }
        )
    }

    return {COLUMNS_ERRORES}
}